<ngb-alert [type]="'danger'" [hidden]="!show" (closed)="close()">
  Your <b>@herokumanager.com</b> email address is no longer supported.
  <a class="alert-link" href="/users/edit" target="_self">Update your email address</a>
  to gain access to notification features.
</ngb-alert>